import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '',
      component: () => import('../layouts/main/Main.vue'),
      children: [
        {
          path: '/',
          redirect: '/home'
        },
        {
          path: '/home',
          name: 'home',
          component: () => import('@/pages/Home/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/home', active: true },
            ],
            pageTitle: 'Storage',
          },
        },
        {
          path: '/documents',
          name: 'documents',
          component: () => import ('@/pages/Documents/All/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/home' },
              { title: 'Documents', url: '/documents', active: true },
            ],
            pageTitle: 'Documents',
          },
        },
        {
          path: '/documents_in_storage',
          name: 'documentsInStorage',
          component: () => import ('@/pages/Documents/InStorage/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/home' },
              { title: 'Documents', url: '/documents' },
              { title: 'In Storage', active: true },
            ],
            pageTitle: 'Documents In Storage',
          },
        },
        {
          path: '/documents_sent_to_storage',
          name: 'documentsSentToStorage',
          component: () => import ('@/pages/Documents/SentToStorage/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/home' },
              { title: 'Documents', url: '/documents' },
              { title: 'Sent To Storage', active: true },
            ],
            pageTitle: 'Documents Sent To Storage',
          },
        },
        {
          path: '/documents_requested_from_storage',
          name: 'documentsRequestedFromStorage',
          component: () => import ('@/pages/Documents/RequestedFromStorage/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/home' },
              { title: 'Documents', url: '/documents' },
              { title: 'In Storage', active: true },
            ],
            pageTitle: 'Documents Requested From Storage',
          },
        },
      ]
    },
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        {
          path: '/login',
          name: 'page-login',
          component: () => import('@/pages/Login.vue')
        },
        {
          path: '/error-404',
          name: 'page-error-404',
          component: () => import('@/pages/Error404.vue')
        },

      ]
    },

    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/error-404'
    }
  ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})


export default router
